module.exports = __webpack_public_path__ + "files/9b5d726e16e02791799d0b1076489d36.svg";